import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
// images
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { Divider, Feature, Hero, PageContainer, Section, RootPageContainer } from "beskar/landing";
import { BrowserWindow, FeaturesBlocks, GoogleLoginButton } from "beskar/src/landing";
import { MyFaq, MyFooter, MyNavbar, MyPricing } from "@app/components/specific";
import { AtSymbolIcon, ChartBarIcon, LightningBoltIcon, ReplyIcon, ChartPieIcon, CheckIcon } from "@heroicons/react/solid";
import { Faded } from "baby-i-am-faded";
import clsx from "classnames";
import { signIn, useSession } from "next-auth/react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import React from "react";
import Image from "next/image";
import colors from "beskar/colors";
import { BlockWithStep } from "beskar/dashboard";
function Page(param) {
    var products = param.products;
    var status = useSession().status;
    var router = useRouter();
    var degree = 0.1;
    return /*#__PURE__*/ _jsxs("div", {
        className: "jsx-d232c94ed63d1a1d" + " " + "text-gray-100 dark bg-gray-900 ",
        children: [
            _jsx(_JSXStyle, {
                id: "d232c94ed63d1a1d",
                children: "html{color-scheme:dark!important}"
            }),
            /*#__PURE__*/ _jsx(Bg, {}),
            /*#__PURE__*/ _jsx(NextSeo, {
                title: "Salespack - Cold email & warmup automation",
                description: "Automate your sales process with cold email, warmup, and follow-up automation. Send personalized emails to your leads and get more responses.",
                canonical: "https://salespack.io"
            }),
            /*#__PURE__*/ _jsxs(RootPageContainer, {
                children: [
                    /*#__PURE__*/ _jsx(MyNavbar, {}),
                    /*#__PURE__*/ _jsx(Hero, {
                        className: "dark",
                        animate: {
                            whenInView: false,
                            delay: 100
                        },
                        bullet: "beta",
                        // image={
                        //     <div className='flex h-full items-end'>
                        //         <img
                        //             src={heroImage.src}
                        //             className={clsx(
                        //                 'opacity-80 min-w-screen min-w-[600px] md:min-w-[1000px]',
                        //                 'lg:-ml-[20px]',
                        //             )}
                        //         />
                        //     </div>
                        // }
                        image: " ",
                        // image={
                        //     <div className='p-8 max-w-[360px] relative'>
                        //         <Image
                        //             className='shadow-lg opacity-40 min-w-[200px]'
                        //             alt='video illustration'
                        //             src={videoCta}
                        //         />
                        //         <VideoModal
                        //             className=''
                        //             aspectRatio={14 / 9}
                        //             button={
                        //                 <div className='flex items-center justify-center absolute inset-0'>
                        //                     <VideoModal.PLayButton className='' />
                        //                 </div>
                        //             }
                        //             youtubeVideoId='ItMyDTdRd_c'
                        //         />
                        //     </div>
                        // }
                        heading: /*#__PURE__*/ _jsxs("span", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "text-6xl font-bold tracking-wide leading-tight",
                            children: [
                                "Your personal sales team,",
                                /*#__PURE__*/ _jsx("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + (clsx("to-sky-200 text-transparent from-blue-300  bg-gradient-to-b", "bg-clip-text") || ""),
                                    children: "completely automated"
                                }),
                                " "
                            ]
                        }),
                        subheading: /*#__PURE__*/ _jsx("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "leading-relaxed",
                            children: "Automate your sales process with cold email, track delivery, and follow-up automation. Send personalized emails to your leads and get more responses."
                        }),
                        // fingerprint={
                        //     <div className="font-semibold">
                        //         7-day free trial. No credit card needed
                        //     </div>
                        // }
                        cta: /*#__PURE__*/ _jsx("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + (clsx("items-center gap-4 flex-col flex md:items-start", "md:flex-row") || ""),
                            children: /*#__PURE__*/ _jsx(GoogleLoginButton, {
                                callbackPath: "/board",
                                bg: "blue.300",
                                bgDark: "blue.500",
                                text: "Sign Up With Google",
                                textColor: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        animate: {
                            whenInView: false,
                            delay: 300
                        },
                        className: "[&_div]:border-gray-600",
                        heading: "10x your replies and revenue"
                    }),
                    /*#__PURE__*/ _jsx(FeaturesBlocks, {
                        blocksClassName: "bg-blue-200 text-gray-900",
                        features: [
                            {
                                heading: "Unlimited email accounts",
                                description: "Use many emails as you want",
                                Icon: AtSymbolIcon
                            },
                            {
                                heading: "Infinite Scale",
                                description: "Capable of millions of emails per day",
                                Icon: LightningBoltIcon
                            },
                            {
                                heading: "Automate Follow-ups",
                                description: "Automate your follow-ups",
                                Icon: ReplyIcon
                            },
                            {
                                heading: "Email warmup",
                                description: "Keep your emails out of spam",
                                Icon: CheckIcon
                            },
                            {
                                heading: "A/B test emails",
                                description: "Experiment with your emails",
                                Icon: ChartPieIcon,
                                bullet: "Coming Soon"
                            },
                            {
                                heading: "Analytics",
                                description: "Track delivery, opens, clicks, and replies",
                                Icon: ChartBarIcon
                            }
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Section, {
                        bg: colors.gray["800"],
                        className: "!py-16",
                        degree: degree,
                        children: /*#__PURE__*/ _jsx(PageContainer, {
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "flex flex-col items-center ",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-4xl font-bold",
                                        children: "How Salespack works"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "jsx-d232c94ed63d1a1d" + " " + "max-w-sm min-w-0 leading-relaxed",
                                        children: [
                                            /*#__PURE__*/ _jsxs(BlockWithStep, {
                                                step: 1,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Connect unlimited email accounts (with warm-up included)"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: "Use salespack warmup to increase deliverability"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(BlockWithStep, {
                                                step: 2,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Automate emails and follow-ups"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: "Salespack will send emails & follow-ups to your leads"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(BlockWithStep, {
                                                isLast: true,
                                                step: 3,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Increase your replies and revenue"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: [
                                                            "Track and analyze your replies and sales performance",
                                                            /*#__PURE__*/ _jsx("br", {
                                                                className: "jsx-d232c94ed63d1a1d"
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {
                                                                className: "jsx-d232c94ed63d1a1d"
                                                            }),
                                                            "Read your leads replies in an unified inbox"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Feature, {
                        animate: true,
                        heading: /*#__PURE__*/ _jsx("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                            children: "Improve email delivery with unlimited warm up"
                        }),
                        subheading: /*#__PURE__*/ _jsxs("div", {
                            className: "jsx-d232c94ed63d1a1d",
                            children: [
                                "Moving from a subdomain to a subdirectory has been proved to improve your domain authority and search traffic.",
                                /*#__PURE__*/ _jsx("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                /*#__PURE__*/ _jsx("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                "Salespack also auto generates a sitemap with all your subpaths."
                            ]
                        }),
                        bullet: "Use Case",
                        // image={
                        //     <div className='max-w-[400px]'>
                        //         <BrowserWindow>
                        //             <div className='w-[400px] h-[220px] bg-gray-800' />
                        //         </BrowserWindow>
                        //     </div>
                        // }
                        image: /*#__PURE__*/ _jsx("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "w-[500px] md:mt-6 rounded-md",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: require("@app/../public/campaign_analytics.png"),
                                placeholder: "blur",
                                className: clsx("rounded-md shrink-0 overflow-hidden")
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ _jsx(Section, {
                            bg: colors.gray["800"],
                            className: "!py-16",
                            degree: degree,
                            children: /*#__PURE__*/ _jsx(Feature, {
                                flip: true,
                                animate: true,
                                heading: /*#__PURE__*/ _jsx("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                    children: "Schedule emails and followups"
                                }),
                                subheading: /*#__PURE__*/ _jsxs("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "",
                                    children: [
                                        "Salespack supports any websites that does not apply CORS restrictions.",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        "Basically you can host all services that also offer custom domains.",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        })
                                    ]
                                }),
                                bullet: "Use Case",
                                image: /*#__PURE__*/ _jsx("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] mt-2 md:-ml-8",
                                    children: /*#__PURE__*/ _jsx(BrowserWindow, {
                                        host: "salespack.io",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            src: require("@app/../public/steps-screen.png"),
                                            placeholder: "blur",
                                            className: clsx("border-0 shrink-0 bg-gray-900 ")
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ _jsx(Feature, {
                            animate: true,
                            heading: /*#__PURE__*/ _jsx("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                children: "Inbox with all your accounts"
                            }),
                            subheading: /*#__PURE__*/ _jsxs("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "",
                                children: [
                                    "Salespack aggregates all your emails in one inbox you can easily monitor and reply to.",
                                    /*#__PURE__*/ _jsx("br", {
                                        className: "jsx-d232c94ed63d1a1d"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {
                                        className: "jsx-d232c94ed63d1a1d"
                                    }),
                                    "Manage all your leads in one place. Stop wasting times with IMAP clients you have to connect for every account."
                                ]
                            }),
                            bullet: "Inbox",
                            image: /*#__PURE__*/ _jsx("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] mt-2",
                                children: /*#__PURE__*/ _jsx(BrowserWindow, {
                                    host: "salespack.io",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        placeholder: "blur",
                                        src: require("@app/../public/inbox-screen.png"),
                                        className: clsx("border-0 shrink-0 brightness-150 bg-gray-900 ", "max-h-[300px]")
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ _jsx(Section, {
                            bg: colors.gray["800"],
                            className: "!py-16",
                            degree: degree,
                            children: /*#__PURE__*/ _jsx(Feature, {
                                animate: true,
                                flip: true,
                                heading: /*#__PURE__*/ _jsx("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                    children: "Create email accounts with your domain directly inside Salespack"
                                }),
                                subheading: /*#__PURE__*/ _jsxs("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "",
                                    children: [
                                        "With Salespack you can create your email accounts without having to rely on Gmail, Outlook, etc.",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        "You can connect your custom domain and have the best email settings to send cold email in no time"
                                    ]
                                }),
                                bullet: "Email Provider",
                                image: /*#__PURE__*/ _jsx("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] md:-ml-12 mt-2",
                                    children: /*#__PURE__*/ _jsx(BrowserWindow, {
                                        host: "salespack.io",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            placeholder: "blur",
                                            src: require("@app/../public/emails-modal-screen.png"),
                                            className: clsx("border-0 shrink-0 brightness-150 bg-gray-900 ", "max-h-[300px]")
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Faded, {
                        whenInView: true,
                        triggerOnce: true,
                        cascade: true,
                        className: "relative flex flex-col gap-8 items-center ",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "text-6xl font-extrabold text-gray-100 text-center",
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ _jsx(MyPricing, {
                                animate: true,
                                orgId: "",
                                promptLogin: function promptLogin() {
                                    return signIn();
                                },
                                products: products,
                                hideUpgradeButton: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(MyFaq, {}),
                    /*#__PURE__*/ _jsx(MyFooter, {})
                ]
            })
        ]
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(Page);
function Bg() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            _jsx(_JSXStyle, {
                id: "950cb27525699f0b",
                children: '.background_main__HFlNS{width:100vw;min-height:100vh;position:absolute;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:120px 24px 160px;pointer-events:none}.background_content__pv7b5{-webkit-transform:translateX(0px)translateY(0px)translateZ(0px);-moz-transform:translateX(0px)translateY(0px)translateZ(0px);transform:translateX(0px)translateY(0px)translateZ(0px);max-width:1800px;background-image:-webkit-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:-moz-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:-o-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:radial-gradient(at 30%10%,#1b72f5 0,transparent 100%);position:absolute;content:"";width:100%;height:40%;-webkit-filter:blur(100px)saturate(150%);filter:blur(100px)saturate(150%);top:80px;opacity:.13}'
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "jsx-950cb27525699f0b" + " " + "background_main__HFlNS",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "jsx-950cb27525699f0b" + " " + "background_content__pv7b5"
                })
            })
        ]
    });
}
